import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landing";
type FloatingCtaProps = {
  visible: boolean;
};
export function FloatingCta({
  visible
}: FloatingCtaProps) {
  return <AnimatePresence data-id="element-155" data-mp="3oxayriwwv8m0">
      {visible && <motion.div initial={{
      y: 24,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 24,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:bottom-4 sm:left-auto sm:right-4 sm:w-auto sm:p-0" data-id="element-156" data-mp="3oym9y3sorin5">
          <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2.5 rounded-2xl bg-gold px-6 py-4 font-display text-[21px] font-extrabold uppercase leading-none text-ink shadow-[0_10px_30px_-6px_rgba(0,0,0,0.6)] ring-2 ring-ink/10 focus:outline-none focus-visible:ring-4 focus-visible:ring-cyan sm:w-auto" data-id="element-157" data-mp="gnj3q37erfn0">
            <ShoppingCartIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-158" data-mp="2b4juji2q40l0" />
            Get it now for $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}